// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"256":"c13ba156","632":"29d16a9c","787":"3ffb02c7"}[chunkId] + ".chunk.js";
};